import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import AlertRoot from 'components/Alert/Root';
import RouterErrorFallback from 'components/GlobalErrorBoundary/RouterErrorFallback';
import ModalRoot from 'components/Modal/Root';

import { AlertProvider } from 'contexts/AlertContext';
import { AuthProvider } from 'contexts/AuthContext';
import { ModalProvider } from 'contexts/ModalContext';

import Routes from 'routes';

const RouterRoot: React.FC = () => {
  return (
    <AuthProvider>
      <ModalProvider>
        <AlertProvider>
          <Routes />
          <ModalRoot />
          <AlertRoot />
        </AlertProvider>
      </ModalProvider>
    </AuthProvider>
  );
};

const router = createBrowserRouter([
  {
    path: '*',
    element: <RouterRoot />,
    errorElement: <RouterErrorFallback />,
  },
]);

const AppRouter: React.FC = () => {
  return <RouterProvider router={router} />;
};

export default AppRouter;
